angular.module('impactx.ruleset').controller('RuleCreationDialogCtrl', [
    '$mdDialog',
    '$scope',
    'themeFactory',
    'abortLabel',
    'forwardLabel',
    'options',
    RuleCreationDialogCtrl]);

function RuleCreationDialogCtrl($mdDialog, $scope, themeFactory, abortLabel, forwardLabel, options) {
    var self = this;
    $scope.options = options;
    $scope.abortLabel = abortLabel;
    $scope.forwardLabel = forwardLabel;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        $mdDialog.hide({
            destinationPage: self.getDestinationPage()
        });
    };

    this.getDestinationPage = function () {
        var i = 0;
        while (i < $scope.options.entries.length) {
            if ($scope.options.entries[i].value == $scope.options.setId) {
                return $scope.options.entries[i].destinationPage;
            }
            i++;
        }
        return null;
    }

}